import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import MembershipCard from "./MembershipCard";
import A1 from "../Images/WhatsApp Image 2026-01-20 at 12.46.23 PM.jpeg";
import { FaCheckCircle, FaDownload, FaEdit, FaEye, FaLink, FaTimesCircle } from "react-icons/fa";
import MembershipCardBack from "./MembershipCardBack";
import { Country, State, City } from "country-state-city";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const RECORDS_PER_PAGE = 10;
const MAX_PAGE_BUTTONS = 5;

const AgencyList = () => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [selected, setSelected] = useState(null);


    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [viewData, setViewData] = useState(null);

    const [editModalOpen, setEditModalOpen] = useState(false);
    const [form, setForm] = useState({
        listing_level: "Level One", // Default selection
    });
    const [statesList, setStatesList] = useState([]);
    const [citiesList, setCitiesList] = useState([]);

    const BLOOD_GROUPS1 = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
    const BLOOD_GROUPS2 = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : type === "file"
                        ? files[0] || null
                        : value || null,
        }));
    };


    useEffect(() => {
        if (form.country) {
            const states = State.getStatesOfCountry(form.country);
            setStatesList(states);
        }
    }, [form.country]);

    useEffect(() => {
        if (form.state) {
            const cities = City.getCitiesOfState(form.country, form.state);
            setCitiesList(cities);
        }
    }, [form.state, form.country]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setLoading(true);
        fetch("https://taaiappapi.emedha.in/pages/api/api/agency")
            .then((res) => res.json())
            .then((result) => {
                setData(result);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    const formatDate = (date) => {
        return date ? date.split("T")[0] : "";
    };

    const handleEditClick = (agency) => {
        setForm({
            ...agency,
            acc_rep1_dob: formatDate(agency.acc_rep1_dob),
            acc_rep1_anniversary: formatDate(agency.acc_rep1_anniversary),
            acc_rep2_dob: formatDate(agency.acc_rep2_dob),
            acc_rep2_anniversary: formatDate(agency.acc_rep2_anniversary),
        });
        setEditModalOpen(true);
    };

    const handleUpdate = async () => {
        try {
            const formData = new FormData();

            // Separate files and text fields
            Object.keys(form).forEach((key) => {
                if (form[key] instanceof File) {
                    // If the user selected a NEW file
                    formData.append(key, form[key]);
                } else if (form[key] !== null && form[key] !== undefined) {
                    // If it's just text or an EXISTING image URL string
                    formData.append(key, form[key]);
                }
            });

            const res = await fetch(`https://taaiappapi.emedha.in/pages/api/api/agency/${form.id}`, {
                method: "PUT",
                body: formData, // Browser sets 'multipart/form-data' automatically
            });

            if (res.ok) {
                alert("Record Updated Successfully!");
                setEditModalOpen(false);
                fetchData(); // Refresh list
            } else {
                const errorData = await res.json();
                alert("Error: " + errorData.error);
            }
        } catch (error) {
            console.error("Update Error:", error);
            alert("Server connection failed");
        }
    };
























    const handleViewDetails = (agency) => {
        setViewData(agency);
        setViewModalOpen(true);
    };


    useEffect(() => {
        fetch("https://taaiappapi.emedha.in/pages/api/api/agency")
            .then((res) => res.json())
            .then((result) => {
                setData(result);
                console.log(result)
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    }, []);


    useEffect(() => {
        if (!selected) return;

        selected.reps.forEach((rep, index) => {
            setTimeout(() => {
                downloadFrontCard(rep);
                downloadBackCard(rep);
            }, index * 600);
        });
    }, [selected]);




    useEffect(() => {
        fetch("https://taaiappapi.emedha.in/pages/api/api/agency")
            .then((res) => res.json())
            .then(setData);
    }, []);

    const filteredData = data.filter((item) => {
        const search = searchTerm.toLowerCase();
        return (
            item.agency_name?.toLowerCase().includes(search) ||
            item.email?.toLowerCase().includes(search) ||
            item.mobile?.toLowerCase().includes(search) ||
            item.acc_rep1_name?.toLowerCase().includes(search)
        );
    });

    const totalPages = Math.ceil(filteredData.length / RECORDS_PER_PAGE);
    const startIndex = (currentPage - 1) * RECORDS_PER_PAGE;
    const paginatedData = filteredData.slice(
        startIndex,
        startIndex + RECORDS_PER_PAGE
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const getPageNumbers = () => {
        const pages = [];
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + MAX_PAGE_BUTTONS - 1);
        if (end - start < MAX_PAGE_BUTTONS - 1) {
            start = Math.max(1, end - MAX_PAGE_BUTTONS + 1);
        }
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    };



    const loggedInEmail = sessionStorage.getItem("userEmail");


    const handleBackToDashboard = () => {
        navigate("/agency-dashboard", { replace: true });
    };


    if (loading) return <p style={{ padding: 20 }}>Loading...</p>;

    const toggleActive = async (id, currentStatus) => {
        const newStatus = currentStatus === 1 ? 0 : 1;

        try {
            const res = await fetch(
                `https://taaiappapi.emedha.in/pages/api/api/agency/status/${id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ is_active: newStatus }),
                }
            );

            const result = await res.json();

            if (result.success) {
                // ✅ Update table data
                setData(prev =>
                    prev.map(item =>
                        item.id === id ? { ...item, is_active: newStatus } : item
                    )
                );

                // ✅ Update modal data instantly
                setViewData(prev =>
                    prev && prev.id === id
                        ? { ...prev, is_active: newStatus }
                        : prev
                );
            } else {
                alert("Failed to update status");
            }
        } catch (error) {
            alert("Server error");
        }
    };








    const downloadFrontCard = async (rep) => {
        const frontEl = document.getElementById(`card-${rep.key}`);
        if (!frontEl) return;

        const frontCanvas = await html2canvas(frontEl, { scale: 2, useCORS: true });
        const link = document.createElement("a");
        link.download = `${rep.name}-card-front.png`;
        link.href = frontCanvas.toDataURL("image/png");
        link.click();
    };

    const downloadBackCard = async (rep) => {
        const backEl = document.getElementById(`card-back-${selected.agency.membership_id}-${rep.key}`);
        if (!backEl) return;

        const backCanvas = await html2canvas(backEl, { scale: 2, useCORS: true });
        const link = document.createElement("a");
        link.download = `${rep.name}-card-back.png`;
        link.href = backCanvas.toDataURL("image/png");
        link.click();
    };




    const handleDownloadCard = (agency) => {
        const reps = [];

        // Accredited Representative 1
        if (agency.acc_rep1_name) {
            reps.push({
                key: "rep1",
                name: agency.acc_rep1_name,
                designation: agency.acc_rep1_designation,
                photo: agency.acc_rep1_passport_photo,
                blood_group: agency.acc_rep1_blood_group,
                mobile: agency.acc_rep1_mobile,   // added mobile
                email: agency.acc_rep1_email,     // added email
            });
        }

        // Accredited Representative 2
        if (agency.acc_rep2_name) {
            reps.push({
                key: "rep2",
                name: agency.acc_rep2_name,
                designation: agency.acc_rep2_designation,
                photo: agency.acc_rep2_passport_photo,
                blood_group: agency.acc_rep2_blood_group,
                mobile: agency.acc_rep2_mobile,   // added mobile
                email: agency.acc_rep2_email,     // added email
            });
        }

        // Set selected to trigger download for each rep
        setSelected({ agency, reps });
    };




    function generateUniqueUrl(length = 9) {
        return Math.random().toString(36).substring(2, 2 + length).toLocaleLowerCase(); // uppercase optional
    }


    const handleGenerateURL = async (agency) => {
        const urlRep1 = agency.acc_rep1_name ? generateUniqueUrl(9) : null;
        const urlRep2 = agency.acc_rep2_name ? generateUniqueUrl(9) : null;

        if (!urlRep1 && !urlRep2) {
            alert("No representatives found");
            return;
        }

        try {
            const response = await fetch(`https://taaiappapi.emedha.in/pages/api/agencymembers/cardurl/${agency.id}`,
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        card_URL_rep1: urlRep1,
                        card_URL_rep2: urlRep2,
                    }),
                }
            );

            if (!response.ok) {
                const err = await response.json();
                console.error(err);
                throw new Error();
            }

            setData(prev =>
                prev.map(item =>
                    item.id === agency.id
                        ? {
                            ...item,
                            ...(urlRep1 && { card_URL_rep1: urlRep1 }),
                            ...(urlRep2 && { card_URL_rep2: urlRep2 }),
                        }
                        : item
                )
            );

            alert("Card URL generated successfully");
        } catch (err) {
            alert("Failed to generate URLs");
        }
    };

























    const handleDownloadExcel = () => {
        if (!data || data.length === 0) return;

        const formattedData = data.map((item) => {

            // Helper function: if value is "1", return "Yes", else return empty string
            const formatYesBlank = (val) => (val === "1" || val === 1 ? "Yes" : " ");

            // Helper to handle nulls/\N for text fields
            const clean = (val) => (
                val === null || val === "\\N" || val === undefined
                    ? " "
                    : val
            );

            // Helper for Listing Level text
            const formatListingLevel = (val) => {

                if (!val || val === "\\N") return " ";

                const level = String(val).trim().toLowerCase();

                switch (level) {

                    case "1":
                    case "level one":
                        return "Level One - Complimentary Listing (One Small Box with Agency Name & Contact Details)";

                    case "2":
                    case "level two":
                        return "Level Two - ₹2,000 (Additional Box for Profile (2x Level One) with LOGO)";

                    case "3":
                    case "level three":
                        return "Level Three - ₹5,000 (Complimentary Listing included in Strip Advertising (Full Width of the Page))";

                    default:
                        return clean(val); // shows original DB value if unmatched
                }
            };

            // Helper for date formatting
            const formatDate = (date) => {
                return date
                    ? new Date(date).toLocaleDateString("en-GB")
                    : " ";
            };

            return {
                // Basic Details
                "ID": clean(item.id),
                "Agency Name": clean(item.agency_name),
                "Category": clean(item.category),
                "Membership ID": clean(item.membership_id),
                "Year of Joining": clean(item.year_of_joining),
                "Address": clean(item.address),
                "City": clean(item.city),
                "State": clean(item.state),
                "Country": clean(item.country),
                "Pin Code": clean(item.pin_code),
                "Email": clean(item.email),
                "Telephone": clean(item.telephone),
                "Mobile": clean(item.mobile),
                "Website": clean(item.website),

                // Representative 1
                "Rep1 Name": clean(item.acc_rep1_name),
                "Rep1 Designation": clean(item.acc_rep1_designation),
                "Rep1 Mobile": clean(item.acc_rep1_mobile),
                "Rep1 Email": clean(item.acc_rep1_email),
                "Rep1 Blood Group": clean(item.acc_rep1_blood_group),
                "Rep1 DOB": formatDate(item.acc_rep1_dob),
                "Rep1 Anniversary": formatDate(item.acc_rep1_anniversary),
                "Rep1 Photo": clean(item.acc_rep1_passport_photo),
                "Rep1 Card URL": clean(item.card_URL_rep1),

                // Representative 2
                "Rep2 Name": clean(item.acc_rep2_name),
                "Rep2 Designation": clean(item.acc_rep2_designation),
                "Rep2 Mobile": clean(item.acc_rep2_mobile),
                "Rep2 Email": clean(item.acc_rep2_email),
                "Rep2 Blood Group": clean(item.acc_rep2_blood_group),
                "Rep2 DOB": formatDate(item.acc_rep2_dob),
                "Rep2 Anniversary": formatDate(item.acc_rep2_anniversary),
                "Rep2 Photo": clean(item.acc_rep2_passport_photo),

                // Section 3: Business Profile
                "Air Ticketing": formatYesBlank(item.air_ticketing),
                "Tourism (Outbound)": formatYesBlank(item.tourism_outbound),
                "Tourism (Inbound & Domestic)": formatYesBlank(item.tourism_inbound_domestic),
                "MICE & Special Events": formatYesBlank(item.mice_events),
                "DMC": formatYesBlank(item.dmc),
                "Online Selling Portals (OTA)": formatYesBlank(item.online_portal),
                "Technology": formatYesBlank(item.technology),
                "Education": formatYesBlank(item.education),
                "Hotels": formatYesBlank(item.hotels),
                "Wedding Planners": formatYesBlank(item.wedding_planners),
                "Others": clean(item.other_activity),

                // Section 4 & 5: Directory Listing Options
                "Directory Level": formatListingLevel(item.directory_level),
                "About Us": clean(item.about_us),
                "Company Logo": clean(item.company_logo),
                "Ad Artwork": clean(item.ad_artwork),

                // Section 6 & 7: Consent & Declaration
                "Digital Consent": formatYesBlank(item.digital_consent),
                "Declaration Consent": formatYesBlank(item.declaration_consent),

            };
        });

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Set column widths
        const wscols = Object.keys(formattedData[0]).map(() => ({
            wpx: 180,
        }));

        worksheet["!cols"] = wscols;

        // =========================
        // HEADER STYLING
        // =========================

        const range = XLSX.utils.decode_range(worksheet["!ref"]);

        // Loop through all header cells
        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({
                r: 0,
                c: col,
            });

            if (!worksheet[cellAddress]) continue;

            worksheet[cellAddress].s = {
                font: {
                    bold: true,
                    color: { rgb: "FFFFFF" }, // White text
                    sz: 12,
                },
                fill: {
                    fgColor: { rgb: "1F4E78" }, // Blue background
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "000000" },
                    },
                },
            };
        }

        // Create workbook
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "TAAI_Directory_Report"
        );

        // Generate Excel buffer
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
            cellStyles: true, // IMPORTANT
        });

        // Create blob
        const fileData = new Blob([excelBuffer], {
            type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });

        // Save file
        saveAs(fileData, "Agency_Directory_Complete.xlsx");
    };

    const handleDownloadPDF = () => {
        if (!data || data.length === 0) {
            alert("No data to export");
            return;
        }

        const doc = new jsPDF("landscape", "mm", "a4");

        const formattedData = data.map((item) => ({
            "ID": item.id,                  // 0
            "Agency Name": item.agency_name,// 1
            "Cat": item.category,           // 2
            "Mem ID": item.membership_id,   // 3
            "Join": item.year_of_joining,   // 4
            "Address": item.address,        // 5
            "City": item.city,              // 6
            "State": item.state,            // 7
            "Email": item.email,            // 8
            "Mobile": item.mobile,          // 9
            "Website": item.website,        // 10
            "Rep 1": item.acc_rep1_name,    // 11
            "Rep 1 Desig": item.acc_rep1_designation, // 12
            "Rep 1 Mob": item.acc_rep1_mobile, // 13
            "Rep 2": item.acc_rep2_name,    // 14
            "Rep 2 Mob": item.acc_rep2_mobile, // 15
            "Air": item.air_ticketing ? "Y" : "N",
            "Out": item.tourism_outbound ? "Y" : "N",
            "In": item.tourism_inbound_domestic ? "Y" : "N",
            "MICE": item.mice_events ? "Y" : "N",
            "Other": item.other_activity || "-", // 20
            "Blood1": item.acc_rep1_blood_group || "-",
            "Blood2": item.acc_rep2_blood_group || "-",
            "Status": item.is_active ? "Active" : "InActive"
        }));

        const tableColumn = Object.keys(formattedData[0]);
        const tableRows = formattedData.map(obj => Object.values(obj));

        doc.setFontSize(10);
        doc.text("Complete Agency Members Report", 14, 10);

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 15,
            theme: "grid",

            styles: {
                fontSize: 5,
                cellPadding: 0.8,
                lineColor: [200, 200, 200],
                lineWidth: 0.1,
                overflow: 'linebreak',
            },

            headStyles: {
                fillColor: [41, 128, 185],
                textColor: [255, 255, 255],
                fontSize: 5,
                fontStyle: 'bold',
                halign: 'center'
            },

            columnStyles: {
                0: { cellWidth: 7 },   // ID
                1: { cellWidth: 30 },  // Agency Name
                2: { cellWidth: 12 },  // Cat (Extended)
                4: { cellWidth: 10 },  // Join (Extended)
                5: { cellWidth: 42 },  // Address (Slightly reduced to balance)
                8: { cellWidth: 22 },  // Email
                9: { cellWidth: 18 },  // Mobile (Extended)
                10: { cellWidth: 20 }, // Website
                15: { cellWidth: 18 }, // Rep 2 Mob (Extended)
                20: { cellWidth: 15 }, // Other Activity
            },

            margin: { top: 15, right: 5, bottom: 10, left: 5 },

            didDrawPage: function (data) {
                doc.setFontSize(6);
                doc.text(
                    "Page " + doc.internal.getNumberOfPages(),
                    data.settings.margin.left,
                    doc.internal.pageSize.height - 5
                );
            }
        });

        doc.save("Full_Agency_Report.pdf");
    };












    //----- edit form data below------------
    // --- INLINE STYLED SUB-COMPONENTS ---

    const Field = ({ label, name, type = "text", value, onChange, placeholder, accept }) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {label && (
                <label style={{ fontSize: '11px', fontWeight: '600', color: '#475569', tracking: '0.2px' }}>
                    {label}
                </label>
            )}
            <input
                type={type}
                name={name}
                value={type !== "file" ? (value || "") : undefined}
                onChange={onChange}
                placeholder={placeholder}
                accept={accept}
                style={{
                    width: '100%',
                    padding: '8px 11px',
                    borderRadius: '6px',
                    border: '1px solid #cbd5e1',
                    boxSizing: 'border-box',
                    fontSize: '12px',
                    color: '#1e293b',
                    backgroundColor: '#ffffff',
                    outline: 'none',
                    transition: 'all 0.15s ease-in-out',
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
                }}
                onFocus={(e) => {
                    e.target.style.borderColor = '#0284c7';
                    e.target.style.boxShadow = '0 0 0 3px rgba(2, 132, 199, 0.12)';
                }}
                onBlur={(e) => {
                    e.target.style.borderColor = '#cbd5e1';
                    e.target.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.03)';
                }}
            />
        </div>
    );

    const Select = ({ label, name, value, options = [], onChange }) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {label && (
                <label style={{ fontSize: '11px', fontWeight: '600', color: '#475569' }}>
                    {label}
                </label>
            )}
            <select name={name} value={value || ""} onChange={onChange} style={{ width: '100%', padding: '8px 11px', borderRadius: '6px', border: '1px solid #cbd5e1', boxSizing: 'border-box', fontSize: '12px', color: '#1e293b', backgroundColor: '#ffffff', outline: 'none', transition: 'all 0.15s ease-in-out', boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)', cursor: 'pointer' }}
                onFocus={(e) => { e.target.style.borderColor = '#0284c7'; e.target.style.boxShadow = '0 0 0 3px rgba(2, 132, 199, 0.12)'; }}
                onBlur={(e) => { e.target.style.borderColor = '#cbd5e1'; e.target.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.03)'; }} >
                <option value="">Select Option</option>
                {options.map((opt) => (
                    <option key={opt} value={opt}>
                        {opt}
                    </option>
                ))}
            </select>
        </div>
    );

    const Checkbox = ({ label, name, checked, onChange }) => (
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: '#334155', cursor: 'pointer', userSelect: 'none' }}>
            <input type="checkbox" name={name} checked={!!checked} onChange={onChange} style={{ width: '15px', height: '15px', accentColor: '#0284c7', cursor: 'pointer', margin: 0 }} />
            <span style={{ fontWeight: checked ? '600' : '400' }}>{label}</span>
        </label>
    );










    return (
        <div >
            {/* HEADER */}
            <div style={{ padding: '20px', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", backgroundColor: '#f8fafc', minHeight: '100vh', boxSizing: 'border-box' }}>

                {/* HEADER */}
                <div style={{ display: 'flex', gap: '15px', marginBottom: '18px', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#ffffff', padding: '14px 18px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
                    {A1 && <img src={A1} alt="Logo" style={{ height: '48px', borderRadius: '6px', objectFit: 'contain' }} />}
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <h3 style={{ margin: 0, fontWeight: '700', color: '#0f172a', fontSize: '15px', letterSpacing: '-0.2px' }}>Travel Agents Association of India</h3>
                        <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#64748b', fontWeight: '500' }}>Membership ID Card Application List</p>
                    </div>
                    <button
                        onClick={handleBackToDashboard}
                        style={{ background: '#ef4444', color: '#ffffff', border: 'none', padding: '7px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '11px', transition: 'background 0.2s', boxShadow: '0 1px 2px rgba(239, 68, 68, 0.2)' }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#dc2626'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ef4444'}
                    >
                        Back to Dashboard
                    </button>
                </div>

                {/* SEARCH & TOOLBAR */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', flexWrap: 'wrap', gap: '10px', backgroundColor: '#ffffff', padding: '12px 16px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
                    <input
                        type="text"
                        placeholder="Search Agency / Email / Mobile / Representative..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ padding: '8px 12px', width: '380px', maxWidth: '100%', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '12px', outline: 'none', backgroundColor: '#f8fafc', color: '#1e293b' }}
                    />
                    <span style={{ fontSize: '11px', color: '#475569', fontWeight: '600' }}>Showing {filteredData.length} record(s)</span>

                    <div style={{ display: 'flex', gap: '6px' }}>
                        {loggedInEmail !== "edittaai@gmail.com" && (
                            <button
                                onClick={handleDownloadExcel}
                                style={{ display: 'flex', alignItems: 'center', gap: '5px', backgroundColor: '#16a34a', color: '#fff', border: 'none', padding: '7px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600', boxShadow: '0 1px 2px rgba(22, 163, 74, 0.2)' }}
                            >
                                <FaFileExcel /> Excel
                            </button>
                        )}
                        {loggedInEmail !== "edittaai@gmail.com" && (
                            <button
                                onClick={handleDownloadPDF}
                                style={{ display: 'flex', alignItems: 'center', gap: '5px', backgroundColor: '#dc2626', color: '#fff', border: 'none', padding: '7px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '600', boxShadow: '0 1px 2px rgba(220, 53, 69, 0.2)' }}
                            >
                                <FaFilePdf /> PDF
                            </button>
                        )}
                    </div>
                </div>

                {/* TABLE WRAPPER */}
                <div style={{ overflowX: "auto", borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', background: 'white', border: '1px solid #e2e8f0' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1000px', fontSize: '11px' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', color: '#475569', borderBottom: '1px solid #e2e8f0' }}>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>#</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Agency Name</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Category</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Email</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Mobile</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Accredited Rep</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>DOB</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Photo</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Directory Level</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Upgrade DL</th>
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Approved</th>
                                {loggedInEmail === "admintaai@gmail.com" && (<th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Card URL</th>)}
                                <th style={{ padding: '9px 10px', textAlign: 'left', fontWeight: '700', fontSize: '11px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.map((item, index) => (
                                <tr key={item.id} style={{ borderBottom: '1px solid #f1f5f9', transition: 'background 0.15s' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'} >
                                    <td style={{ padding: '8px 10px', color: '#64748b' }}>{startIndex + index + 1}</td>
                                    <td style={{ padding: '8px 10px', color: '#0f172a', fontWeight: '600' }}>{item.agency_name}</td>
                                    <td style={{ padding: '8px 10px', color: '#334155' }}>{item.category}</td>
                                    <td style={{ padding: '8px 10px', color: '#334155' }}>{item.email}</td>
                                    <td style={{ padding: '8px 10px', color: '#334155' }}>{item.mobile}</td>
                                    <td style={{ padding: '8px 10px', color: '#334155' }}>{item.acc_rep1_name}</td>
                                    <td style={{ padding: '8px 10px', color: '#334155' }}>{item.acc_rep1_dob ? item.acc_rep1_dob.split("T")[0] : "-"}</td>
                                    <td style={{ padding: '8px 10px' }}>
                                        {item.acc_rep1_passport_photo ? (
                                            <img src={item.acc_rep1_passport_photo} alt="rep" style={{ width: '36px', height: '36px', borderRadius: '4px', objectFit: 'cover', border: '1px solid #e2e8f0' }} />
                                        ) : ("-")}
                                    </td>
                                    <td style={{ padding: '8px 10px', color: '#334155' }}>{item.directory_level}</td>
                                    <td style={{ padding: '8px 10px' }}>
                                        {item.UPGRADE_directory_level && (
                                            <span style={{ display: 'inline-block', padding: '3px 8px', borderRadius: '4px', backgroundColor: '#16a34a', color: 'white', fontWeight: '600', fontSize: '10px', textAlign: 'center', minWidth: '70px' }}>
                                                {item.UPGRADE_directory_level}
                                            </span>
                                        )}
                                    </td>
                                    <td style={{ padding: '8px 10px' }}>
                                        <button style={{ backgroundColor: item.is_active === 1 ? '#16a34a' : '#dc2626', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }} title={item.is_active === 1 ? "Approved" : "Not Approved"}>
                                            {item.is_active === 1 ? <FaCheckCircle /> : <FaTimesCircle />}
                                        </button>
                                    </td>
                                    {loggedInEmail === "admintaai@gmail.com" && (
                                        <td style={{ padding: '8px 10px' }}>
                                            <div style={{ fontSize: '11px', lineHeight: '1.3' }}>
                                                <div><b>R1:</b> {item.card_URL_rep1 ? <a href={`/cardurl/${item.card_URL_rep1}`} target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', textDecoration: 'none' }}>{item.card_URL_rep1}</a> : "-"}</div>
                                                <div><b>R2:</b> {item.card_URL_rep2 ? <a href={`/cardurl/${item.card_URL_rep2}`} target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', textDecoration: 'none' }}>{item.card_URL_rep2}</a> : "-"}</div>
                                            </div>
                                        </td>
                                    )}
                                    <td style={{ padding: '8px 10px' }}>
                                        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                            {loggedInEmail !== "edittaai@gmail.com" && (
                                                <button style={{ border: '1px solid #2563eb', background: 'white', color: '#2563eb', padding: '4px 6px', fontSize: '11px', borderRadius: '4px', minWidth: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} title="View Details" onClick={() => handleViewDetails(item)}><FaEye /></button>
                                            )}
                                            <button style={{ background: '#f59e0b', color: 'white', border: 'none', padding: '4px 6px', fontSize: '11px', borderRadius: '4px', minWidth: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: item.is_active === 1 ? "not-allowed" : "pointer", opacity: item.is_active === 1 ? 0.5 : 1 }} title="Edit Details" onClick={() => item.is_active !== 1 && handleEditClick(item)} disabled={item.is_active === 1}><FaEdit /></button>
                                            {loggedInEmail === "admintaai@gmail.com" && (
                                                <>
                                                    <button style={{ border: '1px solid #cbd5e1', background: 'white', color: '#334155', padding: '4px 6px', fontSize: '11px', borderRadius: '4px', minWidth: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: item.is_active === 0 ? 0.4 : 1, cursor: item.is_active === 0 ? "not-allowed" : "pointer" }} title={item.is_active === 1 ? "Generate URL" : "Activate agency to generate URL"} disabled={item.is_active === 0} onClick={() => item.is_active === 1 && handleGenerateURL(item)} ><FaLink /></button>
                                                    <button style={{ background: '#2563eb', color: 'white', border: 'none', padding: '4px 6px', fontSize: '11px', borderRadius: '4px', minWidth: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: item.is_active === 0 ? 0.4 : 1, cursor: item.is_active === 0 ? "not-allowed" : "pointer" }} title={item.is_active === 1 ? "Download Card" : "Activate agency to download card"} disabled={item.is_active === 0} onClick={() => item.is_active === 1 && handleDownloadCard(item)} ><FaDownload /></button>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* PAGINATION */}
                <div style={{ display: 'flex', gap: '5px', marginTop: '16px', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
                    <button disabled={currentPage === 1} onClick={() => setCurrentPage(1)} style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: 'white', color: '#334155', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', fontSize: '11px', opacity: currentPage === 1 ? 0.5 : 1 }}>First</button>
                    <button disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: 'white', color: '#334155', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', fontSize: '11px', opacity: currentPage === 1 ? 0.5 : 1 }}>Prev</button>
                    {getPageNumbers()[0] > 1 && <span style={{ padding: '4px 6px', color: '#64748b', fontSize: '11px' }}>...</span>}
                    {getPageNumbers().map((page) => (
                        <button key={page} style={{ padding: '5px 10px', borderRadius: '6px', border: currentPage === page ? '1px solid #2563eb' : '1px solid #cbd5e1', background: currentPage === page ? '#2563eb' : 'white', color: currentPage === page ? 'white' : '#334155', cursor: 'pointer', fontSize: '11px', fontWeight: currentPage === page ? '600' : '400' }} onClick={() => setCurrentPage(page)}>{page}</button>
                    ))}
                    {getPageNumbers().slice(-1)[0] < totalPages && (<span style={{ padding: '4px 6px', color: '#64748b', fontSize: '11px' }}>...</span>)}
                    <button disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: 'white', color: '#334155', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', fontSize: '11px', opacity: currentPage === totalPages ? 0.5 : 1 }}>Next</button>
                    <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(totalPages)} style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: 'white', color: '#334155', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', fontSize: '11px', opacity: currentPage === totalPages ? 0.5 : 1 }}>Last</button>
                </div>

                {selected && (
                    <div style={{ position: "absolute", left: "-9999px" }}>
                        {selected.reps.map((rep) => (
                            <React.Fragment key={rep.key}>
                                <MembershipCard agency={selected.agency} rep={rep} />
                                <MembershipCardBack agency={selected.agency} rep={rep} />
                            </React.Fragment>
                        ))}
                    </div>
                )}
            </div>










            <>
                {editModalOpen && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(15, 23, 42, 0.55)',
                        backdropFilter: 'blur(5px)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        overflowY: 'auto',
                        zIndex: 1000,
                        padding: '30px 15px',
                        boxSizing: 'border-box'
                    }}>
                        <div style={{
                            backgroundColor: '#ffffff',
                            width: '100%',
                            maxWidth: '860px',
                            margin: 'auto',
                            borderRadius: '16px',
                            position: 'relative',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #e2e8f0',
                            overflow: 'hidden'
                        }}>
                            {/* CLOSE BUTTON */}
                            <button
                                onClick={() => setEditModalOpen(false)}
                                aria-label="Close Modal"
                                style={{
                                    position: 'absolute',
                                    top: '16px',
                                    right: '18px',
                                    background: '#f1f5f9',
                                    border: 'none',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#64748b',
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 1010,
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#e2e8f0';
                                    e.currentTarget.style.color = '#0f172a';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#f1f5f9';
                                    e.currentTarget.style.color = '#64748b';
                                }}
                            >
                                &times;
                            </button>

                            <div style={{ padding: '24px' }}>
                                <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>

                                    {/* HEADER */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '16px',
                                        marginBottom: '20px',
                                        backgroundColor: '#f8fafc',
                                        padding: '16px 20px',
                                        borderRadius: '12px',
                                        border: '1px solid #e2e8f0'
                                    }}>
                                        <img src={A1} alt="Logo" style={{ height: '46px', objectFit: 'contain' }} />
                                        <div>
                                            <h2 style={{ margin: 0, color: '#0f172a', fontSize: '15px', fontWeight: '700', letterSpacing: '-0.2px' }}>
                                                Travel Agents Association of India
                                            </h2>
                                            <p style={{ margin: '3px 0 0 0', color: '#64748b', fontSize: '11px', fontWeight: '500' }}>
                                                Membership ID Card & Directory Application
                                            </p>
                                        </div>
                                    </div>

                                    {/* SECTION 1: AGENCY DETAILS */}
                                    <section style={{
                                        background: '#ffffff',
                                        padding: '18px 20px',
                                        borderRadius: '12px',
                                        marginBottom: '16px',
                                        border: '1px solid #e2e8f0',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                                    }}>
                                        <h4 style={{
                                            color: '#0284c7',
                                            borderBottom: '1.5px solid #f1f5f9',
                                            paddingBottom: '8px',
                                            marginBottom: '14px',
                                            textTransform: 'uppercase',
                                            fontSize: '11px',
                                            fontWeight: '700',
                                            letterSpacing: '0.5px',
                                            marginTop: 0
                                        }}>
                                            Section 1: Agency Details (Mandatory)
                                        </h4>

                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '12px' }}>
                                            <Field label="Name of Agency" name="agency_name" value={form.agency_name} onChange={handleChange} />
                                            <Select label="Category" name="category" value={form.category} options={["Active", "Associate", "Allied"]} onChange={handleChange} />
                                            <Field label="Year of Joining" name="year_of_joining" type="number" placeholder="e.g., 2026" value={form.year_of_joining} onChange={handleChange} />
                                            <Field label="Agency Membership ID" name="membership_id" value={form.membership_id} onChange={handleChange} />
                                            <Field label="Address" name="address" value={form.address} onChange={handleChange} />

                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                <label style={{ fontSize: '11px', fontWeight: '600', color: '#475569' }}>Country</label>
                                                <select
                                                    name="country"
                                                    value={form.country || ""}
                                                    onChange={handleChange}
                                                    style={{
                                                        width: '100%', padding: '8px 11px', borderRadius: '6px',
                                                        border: '1px solid #cbd5e1', fontSize: '12px', color: '#1e293b',
                                                        backgroundColor: '#fff', outline: 'none', boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
                                                    }}
                                                >
                                                    <option value="">Select Country</option>
                                                    {Country.getAllCountries().map((c) => (
                                                        <option key={c.isoCode} value={c.isoCode}>{c.name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                <label style={{ fontSize: '11px', fontWeight: '600', color: '#475569' }}>State</label>
                                                <select
                                                    name="state"
                                                    value={form.state || ""}
                                                    onChange={handleChange}
                                                    disabled={!statesList.length}
                                                    style={{
                                                        width: '100%', padding: '8px 11px', borderRadius: '6px',
                                                        border: '1px solid #cbd5e1', fontSize: '12px', color: '#1e293b',
                                                        backgroundColor: '#fff', outline: 'none', boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
                                                    }}
                                                >
                                                    <option value="">Select State</option>
                                                    {statesList.map((s) => (
                                                        <option key={s.isoCode} value={s.isoCode}>{s.name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                <label style={{ fontSize: '11px', fontWeight: '600', color: '#475569' }}>City</label>
                                                <select
                                                    name="city"
                                                    value={form.city || ""}
                                                    onChange={handleChange}
                                                    disabled={!citiesList.length}
                                                    style={{
                                                        width: '100%', padding: '8px 11px', borderRadius: '6px',
                                                        border: '1px solid #cbd5e1', fontSize: '12px', color: '#1e293b',
                                                        backgroundColor: '#fff', outline: 'none', boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
                                                    }}
                                                >
                                                    <option value="">Select City</option>
                                                    {citiesList.map((city) => (
                                                        <option key={city.name} value={city.name}>{city.name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <Field label="Pin Code" name="pin_code" value={form.pin_code} onChange={handleChange} />
                                            <Field label="Official Email ID (E-Voting)" name="email" value={form.email} onChange={handleChange} />
                                            <Field label="Official Phone Number" name="telephone" value={form.telephone} onChange={handleChange} />
                                            <Field label="Mobile Number" name="mobile" value={form.mobile} onChange={handleChange} />
                                            <Field label="Website Address" name="website" value={form.website} onChange={handleChange} />
                                        </div>
                                    </section>

                                    {/* SECTION 2: ACCREDITED REPRESENTATIVES */}
                                    <section style={{
                                        background: '#ffffff',
                                        padding: '18px 20px',
                                        borderRadius: '12px',
                                        marginBottom: '16px',
                                        border: '1px solid #e2e8f0',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                                    }}>
                                        <h4 style={{
                                            color: '#0284c7',
                                            borderBottom: '1.5px solid #f1f5f9',
                                            paddingBottom: '8px',
                                            marginBottom: '14px',
                                            textTransform: 'uppercase',
                                            fontSize: '11px',
                                            fontWeight: '700',
                                            letterSpacing: '0.5px',
                                            marginTop: 0
                                        }}>
                                            Section 2: Accredited Representatives (For ID Card)
                                        </h4>

                                        <h5 style={{ fontSize: '12px', fontWeight: '600', color: '#334155', margin: '0 0 10px 0' }}>Primary Representative</h5>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '12px' }}>
                                            <Field label="Full Name" name="acc_rep1_name" value={form.acc_rep1_name} onChange={handleChange} />
                                            <Field label="Designation" name="acc_rep1_designation" value={form.acc_rep1_designation} onChange={handleChange} />
                                            <Field label="Mobile" name="acc_rep1_mobile" value={form.acc_rep1_mobile} onChange={handleChange} />
                                            <Field label="Email" name="acc_rep1_email" value={form.acc_rep1_email} onChange={handleChange} />
                                            <Field label="Date of Birth" name="acc_rep1_dob" type="date" value={form.acc_rep1_dob} onChange={handleChange} />
                                            <Field label="Wedding Anniversary" name="acc_rep1_anniversary" type="date" value={form.acc_rep1_anniversary} onChange={handleChange} />
                                            <Select label="Blood Group" name="acc_rep1_blood_group" value={form.acc_rep1_blood_group} options={BLOOD_GROUPS1} onChange={handleChange} />
                                            <Field label="Upload Photograph" name="acc_rep1_photo" type="file" onChange={handleChange} />
                                        </div>

                                        <div style={{ height: '1px', backgroundColor: '#f1f5f9', margin: '16px 0' }} />

                                        <h5 style={{ fontSize: '12px', fontWeight: '600', color: '#334155', margin: '0 0 10px 0' }}>Secondary Representative (Optional)</h5>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '12px' }}>
                                            <Field label="Full Name" name="acc_rep2_name" value={form.acc_rep2_name} onChange={handleChange} />
                                            <Field label="Designation" name="acc_rep2_designation" value={form.acc_rep2_designation} onChange={handleChange} />
                                            <Field label="Mobile" name="acc_rep2_mobile" value={form.acc_rep2_mobile} onChange={handleChange} />
                                            <Field label="Email" name="acc_rep2_email" value={form.acc_rep2_email} onChange={handleChange} />
                                            <Field label="Date of Birth" name="acc_rep2_dob" type="date" value={form.acc_rep2_dob} onChange={handleChange} />
                                            <Field label="Wedding Anniversary" name="acc_rep2_anniversary" type="date" value={form.acc_rep2_anniversary} onChange={handleChange} />
                                            <Select label="Blood Group" name="acc_rep2_blood_group" value={form.acc_rep2_blood_group} options={BLOOD_GROUPS2} onChange={handleChange} />
                                            <Field label="Upload Photograph" name="acc_rep2_photo" type="file" onChange={handleChange} />
                                        </div>
                                    </section>

                                    {/* SECTION 3: BUSINESS PROFILE */}
                                    <section style={{
                                        background: '#ffffff',
                                        padding: '18px 20px',
                                        borderRadius: '12px',
                                        marginBottom: '16px',
                                        border: '1px solid #e2e8f0',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                                    }}>
                                        <h4 style={{
                                            color: '#0284c7',
                                            borderBottom: '1.5px solid #f1f5f9',
                                            paddingBottom: '8px',
                                            marginBottom: '14px',
                                            textTransform: 'uppercase',
                                            fontSize: '11px',
                                            fontWeight: '700',
                                            letterSpacing: '0.5px',
                                            marginTop: 0
                                        }}>
                                            Section 3: Business Profile
                                        </h4>

                                        <div style={{ marginBottom: '10px' }}>
                                            <label style={{ fontSize: '11px', fontWeight: '600', color: '#334155' }}>
                                                Key Areas of Activity:
                                            </label>
                                            <span style={{ fontSize: '11px', color: '#64748b', fontStyle: 'italic', marginLeft: '6px' }}>
                                                (Tick appropriate vertical/s)
                                            </span>
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '10px' }}>
                                            <Checkbox label="Air Ticketing" name="air_ticketing" checked={form.air_ticketing} onChange={handleChange} />
                                            <Checkbox label="Tourism (Outbound)" name="tourism_outbound" checked={form.tourism_outbound} onChange={handleChange} />
                                            <Checkbox label="Tourism (Inbound/Domestic)" name="tourism_inbound_domestic" checked={form.tourism_inbound_domestic} onChange={handleChange} />
                                            <Checkbox label="MICE & Special Events" name="mice_events" checked={form.mice_events} onChange={handleChange} />
                                            <Checkbox label="DMC" name="dmc" checked={form.dmc} onChange={handleChange} />
                                            <Checkbox label="Online Portals (OTA)" name="online_portal" checked={form.online_portal} onChange={handleChange} />
                                            <Checkbox label="Technology" name="technology" checked={form.technology} onChange={handleChange} />
                                            <Checkbox label="Education" name="education" checked={form.education} onChange={handleChange} />
                                            <Checkbox label="Hotels" name="hotels" checked={form.hotels} onChange={handleChange} />
                                            <Checkbox label="Wedding Planners" name="wedding_planners" checked={form.wedding_planners} onChange={handleChange} />
                                            <Checkbox label="Others" name="others_checkbox" checked={form.others_checkbox} onChange={handleChange} />
                                        </div>

                                        {form.others_checkbox && (
                                            <div style={{ marginTop: '12px' }}>
                                                <Field placeholder="Please specify other activities..." name="other_activity_details" value={form.other_activity_details} onChange={handleChange} />
                                            </div>
                                        )}
                                    </section>

                                    {/* SECTION 4 & 5: DIRECTORY LISTING */}
                                    <section style={{
                                        background: '#ffffff',
                                        padding: '18px 20px',
                                        borderRadius: '12px',
                                        marginBottom: '16px',
                                        border: '1px solid #e2e8f0',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                                    }}>
                                        <h4 style={{
                                            color: '#0284c7',
                                            borderBottom: '1.5px solid #f1f5f9',
                                            paddingBottom: '8px',
                                            marginBottom: '14px',
                                            textTransform: 'uppercase',
                                            fontSize: '11px',
                                            fontWeight: '700',
                                            letterSpacing: '0.5px',
                                            marginTop: 0
                                        }}>
                                            Section 4 & 5: Directory Listing Options
                                        </h4>

                                        <p style={{ fontSize: '11px', color: '#475569', margin: '0 0 12px 0', fontWeight: '500' }}>
                                            * Size of Directory: Similar to A4 size
                                        </p>

                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            <label style={{ fontSize: '11px', fontWeight: '600', color: '#334155' }}>Select Listing Level</label>
                                            {[
                                                { value: "Level One", label: "Level ONE - Complimentary Listing (One Small Box with Agency Name & Contact Details)" },
                                                { value: "Level Two", label: "Level TWO - ₹2,000 (Additional Box for Profile (2x Level One) with LOGO)" },
                                                { value: "Level Three", label: "Level Three – ₹5,000 (Complimentary Listing included in Strip Advertising (Full Width))" }
                                            ].map((opt) => (
                                                <label key={opt.value} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '12px' }}>
                                                    <input
                                                        type="radio"
                                                        name="listing_level"
                                                        value={opt.value}
                                                        checked={form.listing_level === opt.value}
                                                        onChange={handleChange}
                                                        style={{ accentColor: '#0284c7', cursor: 'pointer' }}
                                                    />
                                                    <span style={{ color: form.listing_level === opt.value ? '#0f172a' : '#475569', fontWeight: form.listing_level === opt.value ? '600' : '400' }}>
                                                        {opt.label}
                                                    </span>
                                                </label>
                                            ))}
                                        </div>

                                        <p style={{ fontSize: '11px', color: '#64748b', marginTop: '10px' }}>
                                            (Other advertising options available - Write to <a href="mailto:directory@taai.in" style={{ color: '#0284c7', textDecoration: 'none', fontWeight: '500' }}>directory@taai.in</a>)
                                        </p>

                                        <p style={{ fontSize: '11px', color: '#e11d48', fontWeight: '600', margin: '8px 0 0 0' }}>
                                            Once you confirm Level 2 or Level 3, you will get the separate format for you to fill in.
                                        </p>

                                        {(form.listing_level === "Level Two" || form.listing_level === "Level Three") && (
                                            <div style={{
                                                marginTop: "14px",
                                                padding: "14px",
                                                background: "#f8fafc",
                                                borderRadius: "8px",
                                                border: "1px dashed #cbd5e1",
                                                display: "grid",
                                                gap: "12px"
                                            }}>
                                                <Field label="Upload Company Logo (Max 10MB)" name="company_logo" type="file" accept="image/*" onChange={handleChange} />
                                                {form.listing_level === "Level Three" && (
                                                    <Field label="Upload Strip Ad Artwork (Max 10MB)" name="ad_artwork" type="file" accept="image/*" onChange={handleChange} />
                                                )}
                                            </div>
                                        )}
                                    </section>

                                    {/* SECTION 6 & 7: CONSENT & DECLARATION */}
                                    <section style={{
                                        background: '#ffffff',
                                        padding: '18px 20px',
                                        borderRadius: '12px',
                                        marginBottom: '20px',
                                        border: '1px solid #e2e8f0',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                                    }}>
                                        <h4 style={{
                                            color: '#0284c7',
                                            borderBottom: '1.5px solid #f1f5f9',
                                            paddingBottom: '8px',
                                            marginBottom: '14px',
                                            textTransform: 'uppercase',
                                            fontSize: '11px',
                                            fontWeight: '700',
                                            letterSpacing: '0.5px',
                                            marginTop: 0
                                        }}>
                                            Section 6 & 7: Consent & Declaration
                                        </h4>

                                        <div style={{ background: '#f8fafc', padding: '12px 14px', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            <Checkbox label="I consent to use submitted details for the Membership Directory, Digital Profile/QR Code, and ID Card generation." name="digital_profile_consent" checked={form.digital_profile_consent} onChange={handleChange} />
                                            <Checkbox label="I confirm that the above information is accurate and approved for publication and official use by TAAI." name="declaration_consent" checked={form.declaration_consent} onChange={handleChange} />
                                        </div>
                                    </section>

                                    {/* SUBMIT BUTTON */}
                                    <button
                                        onClick={handleUpdate}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            background: '#0284c7',
                                            color: '#ffffff',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            boxShadow: '0 2px 4px rgba(2, 132, 199, 0.2)',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#0369a1';
                                            e.currentTarget.style.boxShadow = '0 4px 6px rgba(2, 132, 199, 0.25)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#0284c7';
                                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(2, 132, 199, 0.2)';
                                        }}
                                    >
                                        Submit Application
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>








            {viewModalOpen && viewData && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
                    padding: '20px', animation: 'fadeIn 0.2s ease-out'
                }} onClick={() => setViewModalOpen(false)}>

                    <div style={{
                        backgroundColor: '#ffffff', width: '100%', maxWidth: '920px', maxHeight: '88vh',
                        borderRadius: '16px', overflow: 'hidden', display: 'flex', flexDirection: 'column',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        border: '1px solid #f1f5f9'
                    }} onClick={(e) => e.stopPropagation()}>

                        {/* Header */}
                        <div style={{
                            padding: '20px 28px', borderBottom: '1px solid #f1f5f9',
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            backgroundColor: '#f8fafc'
                        }}>
                            <div>
                                <h3 style={{ margin: 0, color: '#1e293b', fontSize: '18px', fontWeight: '700' }}>
                                    {viewData.agency_name}
                                </h3>
                                <p style={{ margin: '4px 0 0 0', color: '#64748b', fontSize: '12px' }}>
                                    Comprehensive Agency & Representative Details
                                </p>
                            </div>
                            <button
                                onClick={() => setViewModalOpen(false)}
                                style={{
                                    background: '#f1f5f9', border: 'none', width: '36px', height: '36px',
                                    borderRadius: '50%', fontSize: '20px', cursor: 'pointer', color: '#64748b',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e2e8f0'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                            >
                                &times;
                            </button>
                        </div>

                        {/* Body */}
                        <div style={{ padding: '28px', overflowY: 'auto', backgroundColor: '#fcfdfd', display: 'flex', flexDirection: 'column', gap: '24px' }}>

                            {/* Section Title */}
                            <div style={{ fontSize: '13px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Agency Overview
                            </div>

                            {/* General Info Grid */}
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))', gap: '12px' }}>
                                {[
                                    { label: 'Agency Name', value: viewData.agency_name },
                                    { label: 'Membership ID', value: viewData.membership_id, bold: true, highlight: true },
                                    { label: 'Category', value: viewData.category },
                                    { label: 'Joining Year', value: viewData.year_of_joining },
                                    { label: 'City / State', value: `${viewData.city || '-'} / ${viewData.state || '-'}` },
                                    { label: 'Mobile', value: viewData.mobile },
                                    { label: 'Email', value: viewData.email },
                                    { label: 'Website', value: viewData.website }
                                ].map((item, idx) => (
                                    <div key={idx} style={{
                                        display: 'flex', border: '1px solid #e2e8f0', borderRadius: '8px',
                                        backgroundColor: '#fff', overflow: 'hidden', boxShadow: '0 1px 2px rgba(0,0,0,0.02)'
                                    }}>
                                        <div style={{
                                            padding: '10px 14px', backgroundColor: '#f8fafc', borderRight: '1px solid #e2e8f0',
                                            width: '130px', minWidth: '130px', fontSize: '11px', fontWeight: '600', color: '#64748b',
                                            display: 'flex', alignItems: 'center'
                                        }}>
                                            {item.label}
                                        </div>
                                        <div style={{
                                            padding: '10px 14px', fontSize: '13px',
                                            color: item.highlight ? '#0284c7' : '#334155',
                                            fontWeight: item.bold ? '700' : '500',
                                            display: 'flex', alignItems: 'center', wordBreak: 'break-all'
                                        }}>
                                            {item.value || '-'}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Full Width Address */}
                            <div style={{ display: 'flex', border: '1px solid #e2e8f0', borderRadius: '8px', backgroundColor: '#fff', overflow: 'hidden' }}>
                                <div style={{
                                    padding: '12px 14px', backgroundColor: '#f8fafc', borderRight: '1px solid #e2e8f0',
                                    width: '130px', minWidth: '130px', fontSize: '11px', fontWeight: '600', color: '#64748b',
                                    display: 'flex', alignItems: 'center'
                                }}>
                                    Address
                                </div>
                                <div style={{ padding: '12px 14px', fontSize: '13px', color: '#334155', lineHeight: '1.5' }}>
                                    {viewData.address ? `${viewData.address}, ${viewData.pin_code || ''}` : '-'}
                                </div>
                            </div>

                            {/* Section Title */}
                            <div style={{ fontSize: '13px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '4px' }}>
                                Business Activities
                            </div>

                            {/* Activities Row */}
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {[
                                    { label: 'Air Ticketing', val: viewData.air_ticketing },
                                    { label: 'Outbound', val: viewData.tourism_outbound },
                                    { label: 'Inbound / Domestic', val: viewData.tourism_inbound_domestic },
                                    { label: 'MICE & Events', val: viewData.mice_events },
                                    { label: 'Online Portal', val: viewData.online_portal }
                                ].map((act, i) => (
                                    <div key={i} style={{
                                        padding: '6px 14px', borderRadius: '20px', fontSize: '12px',
                                        border: '1px solid', fontWeight: '500',
                                        backgroundColor: act.val ? '#eff6ff' : '#f8fafc',
                                        color: act.val ? '#1d4ed8' : '#94a3b8',
                                        borderColor: act.val ? '#bfdbfe' : '#e2e8f0'
                                    }}>
                                        {act.label} {act.val ? '✓' : ''}
                                    </div>
                                ))}
                            </div>

                            {/* Section Title */}
                            <div style={{ fontSize: '13px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '4px' }}>
                                Accredited Representatives
                            </div>

                            {/* Representatives Row */}
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))', gap: '16px' }}>
                                {[
                                    {
                                        name: viewData.acc_rep1_name, des: viewData.acc_rep1_designation,
                                        img: viewData.acc_rep1_passport_photo, email: viewData.acc_rep1_email,
                                        mobile: viewData.acc_rep1_mobile, blood: viewData.acc_rep1_blood_group, title: 'Representative 1'
                                    },
                                    {
                                        name: viewData.acc_rep2_name, des: viewData.acc_rep2_designation,
                                        img: viewData.acc_rep2_passport_photo, email: viewData.acc_rep2_email,
                                        mobile: viewData.acc_rep2_mobile, blood: viewData.acc_rep2_blood_group, title: 'Representative 2'
                                    }
                                ].map((rep, i) => (
                                    <div key={i} style={{
                                        padding: '16px', border: '1px solid #e2e8f0', borderRadius: '12px',
                                        backgroundColor: '#fff', display: 'flex', gap: '16px', alignItems: 'center',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                                    }}>
                                        {rep.img ? (
                                            <img src={rep.img} style={{ width: '64px', height: '64px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f1f5f9', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }} alt="rep" />
                                        ) : (
                                            <div style={{ width: '64px', height: '64px', borderRadius: '50%', backgroundColor: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: '12px', fontWeight: '600' }}>No Image</div>
                                        )}
                                        <div style={{ fontSize: '13px', flex: 1, overflow: 'hidden' }}>
                                            <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>{rep.title}</div>
                                            <div style={{ fontWeight: '700', color: '#1e293b', fontSize: '15px' }}>{rep.name || 'Not Assigned'}</div>
                                            <div style={{ color: '#475569', fontSize: '12px', marginBottom: '6px' }}>{rep.des || 'Designation N/A'}</div>
                                            <div style={{ display: 'flex', gap: '10px', fontSize: '11px', color: '#64748b', flexWrap: 'wrap' }}>
                                                {rep.mobile && <span>📞 {rep.mobile}</span>}
                                                {rep.blood && <span style={{ backgroundColor: '#fef2f2', color: '#dc2626', padding: '1px 6px', borderRadius: '4px', fontWeight: '600' }}>Blood: {rep.blood}</span>}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Footer */}
                        <div style={{
                            padding: '16px 28px', borderTop: '1px solid #f1f5f9',
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            backgroundColor: '#f8fafc'
                        }}>
                            <div style={{ fontSize: '12px', color: '#64748b' }}>
                                Status: <b style={{ color: viewData.is_active === 1 ? '#16a34a' : '#dc2626' }}>
                                    {viewData.is_active === 1 ? 'Approved & Active' : 'Pending Approval'}
                                </b>
                            </div>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                <button
                                    onClick={() => toggleActive(viewData.id, viewData.is_active)}
                                    style={{
                                        padding: '9px 18px', borderRadius: '8px', border: 'none', cursor: 'pointer',
                                        backgroundColor: viewData.is_active === 1 ? '#16a34a' : '#0284c7', color: '#fff',
                                        fontWeight: '600', fontSize: '13px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                        transition: 'opacity 0.2s'
                                    }}
                                >
                                    {viewData.is_active === 1 ? "✓ Approved Member" : "Approve Member"}
                                </button>
                                <button
                                    onClick={() => setViewModalOpen(false)}
                                    style={{
                                        padding: '9px 18px', borderRadius: '8px', border: '1px solid #cbd5e1',
                                        backgroundColor: '#fff', cursor: 'pointer', color: '#334155', fontWeight: '600', fontSize: '13px'
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* STYLES */}
            <style>{`
        .table-page { padding: 25px; font-family: 'Inter', system-ui; background: #f5f7fa; }

        /* HEADER */
        .header { display: flex; gap: 15px; margin-bottom: 20px; align-items: center; justify-content: space-between; }
        .logo { height: 70px; border-radius: 8px; box-shadow: 0 2px 5px rgba(0,0,0,0.1); }
        .header-text { flex: 1; text-align: center; }
        .header-text h3 { margin: 0; font-weight: 600; color: #111827; }
        .header-text p { margin: 2px 0 0; font-size: 14px; color: #6b7280; }

        .btn-logout {
          background: #ef4444;
          color: white;
          border: none;
          padding: 8px 15px;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.2s;
        }
        .btn-logout:hover { background: #dc2626; }

        /* TOOLBAR */
        .toolbar { display: flex; justify-content: space-between; margin-bottom: 15px; flex-wrap: wrap; gap: 10px; }
        .toolbar input { padding: 10px 12px; width: 420px; border-radius: 6px; border: 1px solid #d1d5db; box-shadow: inset 0 1px 3px rgba(0,0,0,0.05); }
        .toolbar span { font-size: 14px; color: #374151; }


      /* TABLE */
        .table-wrapper { overflow-x: auto; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.05); background: white;}
         table { width: 100%; border-collapse: collapse; min-width: 1000px; font-size: 12px; /* smaller font */}
         th, td { padding: 8px 10px; text-align: left; font-size: 12px;}
         thead { background: #f3f4f6; color: #374151;}
         tbody tr {transition: background 0.2s;}
         tbody tr:hover {background: #f9fafb;}
         th {font-weight: 600;}
         td {color: #4b5563;}

        .thumb { width: 50px; height: 50px; border-radius: 6px; object-fit: cover; }

        .btn-active { background: #16a34a; color: white; border: none;  padding: 6px 12px; border-radius: 6px; cursor: pointer;}
        .btn-inactive { background: #dc2626; color: white; border: none; padding: 6px 12px; border-radius: 6px; cursor: pointer;}


      /* ACTION BUTTONS */
        .action-buttons { display: flex; gap: 4px; flex-wrap: wrap;}
        .btn-outline,
        .btn-edit,
        .btn-primary { padding: 4px 8px;  font-size: 11px;  border-radius: 4px; min-width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; cursor: pointer;}
        .btn-outline { border: 1px solid #2563eb; background: white; color: #2563eb; transition: all 0.2s;}
        .btn-outline:hover { background: #2563eb; color: white;}
        .btn-edit { background: #f59e0b; color: white; border: none;}
        .btn-primary { background: #2563eb; color: white; border: none; transition: all 0.2s;}
        .btn-primary:hover { background: #1d4ed8;}

        /* PAGINATION CENTERED */
        .pagination { display: flex; gap: 6px; margin-top: 20px; flex-wrap: wrap; justify-content: center; }
        .pagination button { padding: 6px 12px; border-radius: 6px; border: 1px solid #d1d5db; background: white; color: #374151; cursor: pointer; transition: all 0.2s; }
        .pagination button.active { background: #2563eb; color: white; border-color: #2563eb; }
        .pagination button:hover:not(.active):not(:disabled) { background: #f3f4f6; }
        .pagination button:disabled { opacity: 0.5; cursor: not-allowed; }
        .dots { padding: 6px 8px; color: #6b7280; }

        @media (max-width: 640px) {
          .header { flex-direction: column; text-align: center; }
          .header-text { text-align: center; margin-bottom: 10px; }
          .toolbar { flex-direction: column; align-items: center; }
        }
      `}</style>


            <style>{`
       .modal-overlay {  position: fixed;  top: 0; left: 0;  width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex;  align-items: center;  justify-content: center; z-index: 1000;}
       .modal-content { background: white;  padding: 25px;  border-radius: 8px;  max-height: 80vh;  overflow-y: auto;  width: 90%;  max-width: 700px; box-shadow: 0 5px 15px rgba(0,0,0,0.3);}
       .details-table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
       .details-table td { padding: 8px 12px; border-bottom: 1px solid #e5e7eb; }
       .details-table td:first-child { font-weight: 600; color: #374151; width: 35%; }
       `}</style>

        </div >
    );
};


const Field = ({ label, name, value, onChange, type = "text", placeholder }) => (
    <div className="field">
        <label>{label}</label>
        <input type={type} name={name} placeholder={placeholder || `Enter ${label}`} onChange={onChange} value={type === "file" ? undefined : value} />
    </div>
);

const Select = ({ label, name, options, value, onChange }) => (
    <div className="field">
        <label>{label}</label>
        <select name={name} value={value} onChange={onChange}>
            <option value="">Select {label}</option>
            {options.map((o) => (
                <option key={o} value={o}>{o}</option>
            ))}
        </select>
    </div>
);

const Checkbox = ({ label, name, checked, onChange }) => (
    <label style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "14px", cursor: "pointer" }}>
        <input type="checkbox" name={name} checked={checked} onChange={onChange} style={{ width: "18px", height: "18px" }} /> {label}
    </label>
);

export default AgencyList;
